import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { getImageAssetPath } from '@/lib/imageHelper';
import OptimizedImage from '@/components/common/OptimizedImage';

const ShopwareHero = () => {
  const shopwareLogoPath = getImageAssetPath('shopware-logo.png');
  
  return (
    <section className="pt-12 pb-20 md:py-24 overflow-hidden bg-gradient-to-br from-white to-blue-50">
      <div className="container">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="w-full lg:w-1/2 space-y-6">
            <div className="flex items-center gap-2 mb-4">
              <span className="bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">Shopware Agentur</span>
              <span className="bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">Zertifizierter Partner</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              <span className="text-blue-600">Shopware Shop</span> programmieren lassen
            </h1>
            
            <h2 className="text-xl md:text-2xl text-gray-700 font-medium">Individuelle B2B & B2C Online-Shops für maximalen Verkaufserfolg</h2>
            
            <p className="text-lg text-gray-600">
              Als zertifizierte <strong className="text-blue-700">Shopware Agentur</strong> entwickeln wir maßgeschneiderte 
              B2B und B2C Shops, die perfekt auf deine Geschäftsprozesse abgestimmt sind und für 
              höchste Conversion-Raten sorgen.
            </p>
            
            <div className="pt-2">
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <Check className="text-green-500 h-5 w-5 flex-shrink-0" />
                  <span className="text-gray-700">Langjährige Shopware-Expertise seit Version 4</span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="text-green-500 h-5 w-5 flex-shrink-0" />
                  <span className="text-gray-700">Perfekte Integration in bestehende Systeme (ERP, CRM, PIM)</span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="text-green-500 h-5 w-5 flex-shrink-0" />
                  <span className="text-gray-700">Maßgeschneiderte Designs mit Conversion-Optimierung</span>
                </li>
              </ul>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-6">
              <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-8">
                <a href="#contact">Kostenlose Beratung anfragen</a>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-blue-200 hover:bg-blue-50">
                <a href="#shopware-features" className="flex items-center gap-2">
                  Shopware Funktionen kennenlernen
                  <ArrowRight size={16} />
                </a>
              </Button>
            </div>
            
            <div className="flex items-center gap-4 pt-6">
              <p className="text-sm text-gray-500">Offizieller Shopware Partner</p>
              <div className="w-32 h-auto">
                <OptimizedImage
                  src={shopwareLogoPath || 'https://assets.shopware.com/media/logos/shopware_logo_blue.svg'}
                  alt="Shopware Partner Logo"
                  width={128}
                  height={40}
                />
              </div>
            </div>
          </div>
          
          <div className="w-full lg:w-1/2 relative">
            <div className="relative z-10 bg-white rounded-xl shadow-xl overflow-hidden">
              <div className="aspect-[16/9] relative">
                <img 
                  src="https://via.placeholder.com/800x450?text=Shopware+B2B+Shop+Beispiel"
                  alt="Shopware Shop Beispiel" 
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                Referenz-Projekt
              </div>
            </div>
            
            <div className="absolute top-8 -right-12 transform rotate-12 bg-gradient-to-br from-green-500 to-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-0">
              <span className="font-bold">+45%</span> Conversion-Rate
            </div>
            
            <div className="absolute -bottom-4 -left-8 bg-gradient-to-br from-amber-500 to-amber-600 text-white px-6 py-3 rounded-lg shadow-lg z-0">
              <span className="font-bold">-32%</span> Warenkorbabbrüche
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopwareHero; 